import React from 'react';
import Header from './components/Header';
import Footer from './components/Footer';
import './App.css';
import PromoSection from './components/PromoSection';
import CustomerSupport from './components/CustomerSupport';
import BetPlaceSection from './components/BetPlace';
import InstaSection from './components/Instagram';
import WhatsAppButton from './components/Whatsapp';

function App() {
  return (
    <div className="App">
      <Header />
      <CustomerSupport />
      <PromoSection />
      <InstaSection />
      <BetPlaceSection />
      <WhatsAppButton />
      <Footer />
    </div>
  );
}

export default App;
